import Helpers from '@helpers';
import * as React from 'react';
import { drpDownUpgraded } from './inputUpgraded';


class AdminMasterController extends React.Component {
    constructor(props) {
        super(props);
    }

    public componentDidMount() {
        drpDownUpgraded();

        this.menuClickHandler();
        this.highlightActiveMenu();

        $('.price-seprating').keyup(function() {
            const textBox = $(this);
            if (textBox.hasClass('no-separate')) {
                return;
            }
            const textBoxValue = textBox.val().toString().replace(/[^\d.]/g, '');
            const textBoxLen = textBoxValue.length;
            const remainLen = textBoxLen % 3;
            let result = '';
            const separator = ',';

            if (remainLen > 0) {
                if (textBoxLen < 4) {
                    result = textBoxValue;
                } else {
                    result = textBoxValue.substring(0, remainLen) + separator;
                }
            }

            for (let i = 0; i < (textBoxLen - remainLen); i += 3) {
                if (i === textBoxLen - remainLen - 3) {
                    result += textBoxValue.substring(remainLen + i, remainLen + i + 3);
                } else {
                    result += textBoxValue.substring(remainLen + i, remainLen + i + 3) + separator;
                }
            }

            if (textBox.val().toString() === result) return;
            textBox.val(result);

        });

        $('.col-checkbox').change(function () {
            const index = $('.col-checkbox').parent('td').index()+1;
            $('.list-table tr>td:nth-child(' + index+') input[type=checkbox]').prop("checked", $('.col-checkbox').is(":checked"));
        });
    }

    public menuClickHandler() {
        const selector = '.menu-wrapper > li > div';
        $(selector).off('click');
        $(selector).on('click', function(e) {
            const subMenu = $(this).next();
            if (!subMenu.is(':visible')) {
                $('.submenu-wrapper').slideUp();
                $(this).next().slideToggle();
            }
        });
    }

    public highlightActiveMenu() {
        $('.menu-item-active').closest('ul').show();

        $.each($('.submenu-wrapper'), (index, element) => {
            if ($(element).find('a').length === 0) {
                $(element).closest('li').hide();
            }
        });
    }

    public render() {
        return null;
    }
}

Helpers.ReactHelper.createReactElement('AdminMasterController', AdminMasterController);
